import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import InsideCompany from './views/InsideCompany.vue'
import CompanyPanel from './views/CompanyPanel.vue'
import SalesBusiness from './views/SalesBusiness.vue'
import ProjectStart from './views/ProjectStart.vue'
import Purchase from './views/Purchase.vue'
import CompanyStock from './views/CompanyStock.vue'
import CompanySetting from './views/CompanyStock.vue'
import WeChatApply from './views/WeChatApply.vue'

import ReleaseContent from './views/ReleaseContent.vue'
import wozaiqiye from './views/releasePage/wozaiqiye.vue'
import shouye from './views/releasePage/shouye.vue'

Vue.use(Router)

//防止子路由多次点击出错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
};

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/InsideCompany',
      name: 'InsideCompany',
      component: () => import('@/views/InsideCompany.vue')
    },
    {
      path: '/CompanyPanel',
      name: 'CompanyPanel',
      component: () => import('@/views/CompanyPanel.vue')
    },
    {
      path: '/SalesBusiness',
      name: 'SalesBusiness',
      component: () => import('@/views/SalesBusiness.vue')
    },
    {
      path: '/ProjectStart',
      name: 'ProjectStart',
      component: () => import('@/views/ProjectStart.vue')
    },
    {
      path: '/Purchase',
      name: 'Purchase',
      component: () => import('@/views/Purchase.vue')
    },
    {
      path: '/CompanyStock',
      name: 'CompanyStock',
      component: () => import('@/views/CompanyStock.vue')
    },
    {
      path: '/CompanySetting',
      name: 'CompanySetting',
      component: () => import('@/views/CompanySetting.vue')
    },
    {
      path: '/WeChatApply',
      name: 'WeChatApply',
      component: () => import('@/views/WeChatApply.vue')
    },
    {
      path: '/ReleaseContent',
      name: 'ReleaseContent',
      component: () => import('@/views/ReleaseContent.vue'),
      redirect:"/ReleaseContent/wozaiqiye",
      children:[
        {
          path: '/ReleaseContent/shouye',
          name: 'shouye',
          component: () => import('@/views/releasePage/shouye.vue'),
        },
        {
          path: '/ReleaseContent/wozaiqiye',
          name: 'wozaiqiye',
          component: () => import('@/views/releasePage/wozaiqiye.vue'),
        }
      ]
    },
  ]
})
